import catalogModule from '../catalogModule';
import menuConstants from '../constants/menuConstants';

function searchOptionsController($log, $scope, catalogConstants, constantsService) {
  'ngInject';

  $scope.canShowFilters = () => {
    return (
      !$scope.library.isSplashPage && $scope.isSearchableCategory($scope.currentQuery.category)
    );
  };

  $scope.canToggleSubmenu = category => {
    const { subcategories, categoryId } = category;
    return (
      subcategories &&
      subcategories.length > 0 &&
      (!$scope.currentQuery.category || $scope.currentQuery.category.categoryId !== categoryId)
    );
  };
}

catalogModule.controller('searchOptionsController', searchOptionsController);

export default searchOptionsController;
